(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-columns/assets/javascripts/banner-columns.js') >= 0) return;  svs.modules.push('/widgets/banner-columns/assets/javascripts/banner-columns.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_columns = svs.widget.banner_columns || {};
svs.widget.banner_columns.init = svs.banner_groups.banner_columns.init;

 })(window);